export default __webpack_public_path__ + "static/media/date-update.94163264.svg";